export default __webpack_public_path__ + "static/media/home-display-shadow.f7889a0e.png";